import { render, staticRenderFns } from "./ClosedPostCard.vue?vue&type=template&id=51a62a8b&scoped=true&"
import script from "./ClosedPostCard.vue?vue&type=script&lang=js&"
export * from "./ClosedPostCard.vue?vue&type=script&lang=js&"
import style0 from "./ClosedPostCard.vue?vue&type=style&index=0&id=51a62a8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a62a8b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/shashwat/CampusBox/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardTitle,VDivider,VIcon,VSpacer,VTab,VTabItem,VTabs})
